import config from "../config";
import {
  concatOptionalParameter,
  sendPostRequest,
  sendGetRequest,
  sendPostRequestReturnValue,
} from "./../Utility/FetchUtils";
import { EModuleType } from "../Model/EModuleType";
import { PlateAddress } from "../Model/PlateAddress";
import { sendDownloadTextRequest } from "../Utility/FetchUtils";
import { ImagingPreferences } from "../Model/ImagingPreferences";
import { Plate, CanMovePlate } from "../Model/Plate";

class PlateApi {

  static BASE_URL = config.SERVICE_URL + "/plate";

  static exportPlateAddress(plateAdresses: PlateAddress[], filename: string) {
    let url = this.BASE_URL + "/:export";
    return sendPostRequestReturnValue<string>(url, plateAdresses).then(
      (date) => {
        const getUrl = this.BASE_URL + "/export/" + date;
        return sendDownloadTextRequest(getUrl, filename);
      }
    );
  }

  static imagePlate(
    barcode: string,
    imagingPreferences: ImagingPreferences,
    imagerIdentifier?: string
  ) {
    let url = PlateApi.BASE_URL + "/:image-plate/" + encodeURIComponent(barcode);

    url = concatOptionalParameter(url, {
      "imager-identifier": imagerIdentifier,
    });

    return sendPostRequest(url, imagingPreferences);
  }

  static canMovePlate(plate: Plate) {
    const url = this.BASE_URL + "/can-move-plate/" + encodeURIComponent(plate.barcode);
    return sendGetRequest<CanMovePlate[]>(url);
  }

  static canMovePlateAddress(plateAddresses: PlateAddress[]) {
    let url = this.BASE_URL + "/can-move-plate-address";
    url = concatOptionalParameter(url, {
      ids: plateAddresses.map((p) => p.id),
    });
    return sendGetRequest<CanMovePlate[]>(url);
  }

  static getPlates(
    moduleIdentifier: string,
    moduleType: EModuleType,
    hotelNumber: number,
    slotNumber: number,
    barcodes: string[]
  ) {
    let url = this.BASE_URL;
    url = concatOptionalParameter(url, {
      "module-identifier": moduleIdentifier,
      "module-type": moduleType,
      "hotel-number": hotelNumber,
      "slot-number": slotNumber,
      barcodes: barcodes,
    });
    return sendGetRequest(url);
  }

  static cancelMovePlates(plateAddresses: PlateAddress[]) {
    const url = this.BASE_URL + "/:cancel-move";
    return sendPostRequest(url, plateAddresses);
  }

  static movePlateToStorage(plateAddresses: PlateAddress[]) {
    const url = this.BASE_URL + "/:move-to-storage";
    return sendPostRequest(url, plateAddresses);
  }

  static movePlateToLoadPort(plateAddresses: PlateAddress[]) {
    const url = this.BASE_URL + "/:move-to-loadport";
    return sendPostRequest(url, plateAddresses);
  }

  static movePlateToImager(
    plateAddress: PlateAddress,
    imager_identifier: string
  ) {
    const url = this.BASE_URL + "/" + imager_identifier + "/:move-to-imager";
    return sendPostRequest(url, plateAddress);
  }

  static returnPlate(imager_identifier: string) {
    const url = this.BASE_URL + "/" + imager_identifier + "/:return";
    return sendPostRequest(url);
  }

  static returnAbandonedPlate() {
    const url = this.BASE_URL + "/:return-abandoned-plate";
    return sendPostRequest(url);
  }

  static getReferencePlate() {
    const url = this.BASE_URL + "/reference-plate";
    return sendGetRequest<Plate>(url);
  }

  static clearImagerPlateRegistration() {
    const url = this.BASE_URL + "/:clear-imager-plate-registration";
    return sendPostRequest(url);
  }

  static acknowledgeMultiplePlateRetrievalError() {
    const url = this.BASE_URL + "/:acknowledge-multiple-plate-retrieval-error";
    return sendPostRequest(url);
  }

  static updatePlateInfo(barcodes:string[]) {
    const url = this.BASE_URL + "/:update-plate-information";
    return sendPostRequest(url, barcodes);
  }

  static stopRetryStoreAndRetrieve() {
    const url = this.BASE_URL + "/:stop-retry-store-and-retrieve";
    return sendPostRequest(url);
  }
}

export default PlateApi;
